import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  useMediaQuery,
  AppBar,
  Toolbar,
  IconButton,
  Icon,
  Typography,
  Container,
  Box,
  Slide,
  Input,
  InputAdornment
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/styles";
import { useState } from "react";
import { useContext } from "react";
import { MasterContext } from "../../context/master";
import { useEffect } from "react";
import { PasswordGenerator, ValidateHostname } from "../../utils/Utils";
import SexyLoader from "../../components/interaction/sexyLoader";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: "100%"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  appBar: { ...theme.mixins.toolbar, marginTop: theme.spacing(2) },
  siteAddBox: {
    borderStyle: "dotted",
    width: "100%",
    borderColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide unmountOnExit direction="up" ref={ref} {...props} />;
});

const PacketAddDialog = props => {
  const classes = useStyles();
  const theme = useTheme();
  const context = useContext(MasterContext);

  const { t } = useTranslation();

  /*İÇERİK DEĞİŞECEK FİKİR AL*/
  return (
    <>
      <Container maxWidth={false}>
        <Grid container justify="center" >
          <Box textAlign="center" className={classes.siteAddBox} p={3}>
            <Button
              size="large"
              color="secondary"
              startIcon={<Icon>add</Icon>}
              variant="outlined"
              onClick={() =>
                window.open(
                  "https://www.natro.com/hosting/wordpress-hosting",
                  "_blank"
                )
              }
            >
              {t("ADD PACKET")}
            </Button>
          </Box>
        </Grid>
      </Container>
      {/*<Dialog
        TransitionComponent={Transition}
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        {!fullScreen ? (
          <DialogTitle>{t("Create Site")}</DialogTitle>
        ) : (
          <AppBar color="default">
            <Toolbar>
              <IconButton
                onClick={() => setDialogOpen(false)}
                edge="start"
                className={classes.menuButton}
              >
                <Icon>close</Icon>
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {t("Create Site")}
              </Typography>
              <Button onClick={handleCreate} color="inherit">
                {t("CREATE")}
              </Button>
            </Toolbar>
          </AppBar>
        )}
        {fullScreen && <div className={classes.appBar}></div>}
        <DialogContent className={classes.content}>
          <DialogContentText>
            Adipisicing ipsum commodo fugiat excepteur sit dolore sint.
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid xs={12} item>
              <FormControl className={classes.formControl}>
                <InputLabel>{t("Account")}</InputLabel>
                <Select
                  onChange={event => setSelectedAccount(event.target.value)}
                  value={selectedAccount}
                  disabled={props.AccountID}
                >
                  {accounts
                    .filter(
                      account =>
                        account.Sites.length < account.Account.LimitWebSpaces
                    )
                    .map((account, accountIndex) => (
                      <MenuItem
                        value={account.Account.Account_ID}
                        key={account.Account.Account_ID}
                      >
                        {`${account.Account.Account_Name} - ${account.Account.PackageName} - ${account.Sites.length}/${account.Account.LimitWebSpaces}`}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} item>
              <TextField
                value={hostname}
                onChange={event => setHostname(event.target.value)}
                autoFocus
                error={hostnameError}
                helperText={hostnameHelper}
                fullWidth
                label="Host Name"
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={username}
                onChange={event => setUsername(event.target.value)}
                error={usernameError}
                helperText={usernameHelper}
                fullWidth
                label={t("Username")}
              ></TextField>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="standard-adornment-password">
                  {t("Password")}
                </InputLabel>
                <Input
                  id="standard-adornment-password"
                  value={password}
                  onChange={event => setPassword(event.target.value)}
                  error={passwordError}
                  helperText={passwordHelper}
                  type={passwordType}
                  fullWidth
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setPasswordType(
                            passwordType === "password" ? "text" : "password"
                          )
                        }
                      >
                        <Icon>
                          {passwordType === "password"
                            ? "visibility"
                            : "visibility_off"}
                        </Icon>
                      </IconButton>
                    </InputAdornment>
                  }
                ></Input>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        {!fullScreen && (
          <DialogActions>
            <SexyLoader IsLoading={Loading}>
              <Button onClick={() => setDialogOpen(false)} color="default">
                {t("CANCEL")}
              </Button>

              <Button
                disabled={
                  !hostname || !selectedAccount || !username || !password
                }
                onClick={handleCreate}
                color="primary"
              >
                {t("CREATE")}
              </Button>
            </SexyLoader>
          </DialogActions>
        )}
      </Dialog>*/}
    </>
  );
};

export default PacketAddDialog;
